import { useCallback } from 'react'

import { usePublicClient } from 'wagmi'
import { createWalletClient, http } from 'viem'
import { privateKeyToAccount } from 'viem/accounts'

import { Hash } from 'types/entities'

import { useSettingRpcUrl } from 'state/user/hooks'

export function usePrivateKeyWallet() {
  const { chain } = usePublicClient()
  const rpcUrl = useSettingRpcUrl()

  return useCallback(
    (privateKey: Hash) => {
      const account = privateKeyToAccount(privateKey)

      return createWalletClient({
        account,
        chain,
        transport: http(),
      })
    },
    [chain, rpcUrl],
  )
}
